<!--  -->
<template>
    <div>
        <van-form @submit="onSubmit" scroll-to-error input-align="right" error-message-align="right">
            <div class="filing-application" :class="!disable ? 'margin-bottom' : ''">
                <!-- 车场信息 -->
                <div class="filing-application-item">
                    <van-cell value="基本信息" />
                    <van-field :required="!disable" :disabled="disable" v-model="formData.phoneNo" name="phoneNo" label="手机号码" placeholder="请输入手机号码" :rules="[{ required: true, message: '请输入手机号码' }]" />
                    <!-- <van-field :required="!disable" :disabled="disable" v-model="formData.plateNum" name="plateNum" maxlength="20" label="车牌号码" placeholder="请输入车牌号码" :rules="[{ required: true, message: '请输入车牌号码' }]" /> -->

                    <van-field :required="!disable" :disabled="disable" v-model="formData.plateNum" :is-link="formData.plateNum ? false : true" readonly name="plateNum" label="车牌号码" placeholder="点击选择车牌" @click="showPicker(2)">
                        <template #input>
                            <div v-if="!formData.plateNum" style="color: #c8c9cc">点击选择用户车牌</div>
                            <div v-if="formData.plateNum" :style="disable ? 'color:#c8c9cc' : ''">
                                {{ formData.plateNum }}
                            </div>
                        </template>
                    </van-field>
                    <van-field :required="!disable" :disabled="disable" v-model="formData.type" :is-link="formData.type ? false : true" readonly name="type" label="用户类型" placeholder="点击选择用户类型" @click="showPicker(1)">
                        <template #input>
                            <div v-if="!formData.type" style="color: #c8c9cc">点击选择用户类型</div>
                            <div v-if="formData.type" :style="disable ? 'color:#c8c9cc' : ''">
                                {{ formData.typeName }}
                            </div>
                        </template>
                    </van-field>
                    <form-upload :required="false" title="图片" :url.sync="formData.imageUrls" :maxCount="4" :disable="disable" />

                </div>

                <div v-if="status == 4" class="filing-application-item">
                    <van-cell value="审核未通过原因" />
                    <VanField disabled v-model="formData.remark" input-align="left" rows="3" type="textarea" name="auditRemark" label="" maxlength="200"> </VanField>
                </div>
            </div>

            <div class="bottom" v-if="!disable">
                <van-button block form-type="submit" class="bottom-button">
                    {{ status == 2 ? "重新提交" : "提交申请" }}
                </van-button>
            </div>
        </van-form>
        <div v-if="formData.typeName =='教师'" class="info">温馨提醒：需上传本人的教师资格证、在岗证明、行驶证。</div>
        <div v-if="formData.typeName =='残疾人'" class="info">温馨提醒：需上传本人的身份证、残疾人证、驾驶证、行驶证。</div>
        <popup v-model="showChoseType" round position="bottom">
            <picker title="请选择用户类型" show-toolbar :columns="workbookList" value-key="menuName" @confirm="onTypeConfirm" @cancel="showChoseType = false" />
        </popup>

        <popup v-model="showChosePlateNum" round position="bottom">
            <picker title="请选择车牌" show-toolbar :columns="plateNumList" value-key="plateNum" @confirm="onPlateNumConfirm" @cancel="showChosePlateNum = false" />
        </popup>
    </div>
</template>

<script>
import { Popup, Picker } from "vant";
import FormUpload from "@/components/base/upload/formUpload.vue";
import { fileList } from "./fileList";
import { submitAuthCert, reSubmitAuthCert, listWorkbook, listMyPlateNum } from '@/api/api'
import Info from "@/components/base/info/index.vue";
let formlist = {
    "imageUrls": "",
    "phoneNo": "",
    "plateNum": "",
    "type": "",
}
export default {
    name: '',

    components: {
        Popup,
        Picker,
        Info,
        FormUpload,
    },

    data() {
        return {
            disable: false,
            formData: { ...formlist },
            status: -1,
            workbookList: [],
            plateNumList: [],
            showChoseType: false,
            showChosePlateNum: false
        };
    },

    computed: {},
    async mounted() {
        //  <!-- 审核状态  1 未审核 2 审核中 3 已认证 4 驳回 -->
        let item = this.$route.query;
        this.workbookList = await listWorkbook({ "workbookCode": "0005" }).then(res => res.data)
        this.plateNumList = await listMyPlateNum().then(res => res.data)

        if (item.status) {
            this.status = item.status;
            if (item.status == 2 || item.status == 3) {
                this.disable = true;
            }
            this.formData = item
        }

    },

    methods: {


        onSubmit(value) {
            let flagItem = this.judgmentFile(this.formData);
            if (!flagItem.flag) {
                this.$toast(`${flagItem.fileName}不能为空，请上传`);
                return;
            }

            if (this.status == -1) this.add(this.formData);
            else this.update(this.formData);
        },
        // 新增
        add(formData) {
            submitAuthCert(formData).then((res) => {
                this.$toast("提交成功！");
                this.$router.back();
            });
        },
        update(fromData) {
            reSubmitAuthCert(fromData).then((res) => {
                this.$toast("重新提交成功！");
                this.$router.back();
            });
        },

        judgmentFile(formData) {
            let fileName = "";
            let flag = fileList.every((item) => {
                if (!formData[item.key]) fileName = item.name;
                return formData[item.key];
            });
            return { flag, fileName };
        },

        showPicker(index) {
            if (this.disable) return
            if (index == 1) this.showChoseType = true;
            else if (index == 2) this.showChosePlateNum = true;
        },
        onTypeConfirm(value) {
            this.formData.type = value.code;
            this.formData.typeName = value.menuName;
            this.showChoseType = false;
        },
        onPlateNumConfirm(value) {
            this.formData.plateNum = value.plateNum;
            this.showChosePlateNum = false;

        }
    }
}

</script>
<style lang="less" scoped>
.info {
    font-size: 28px;
    color: #616161;
    padding: 20px 30px;
}
.filing-application {
    border-radius: 20px;
    width: 702px;
    height: auto;
    margin: 15px 24px 0 24px;

    .filing-application-item {
        border-radius: 20px;
        overflow: hidden;
        margin-bottom: 25px;
    }
}

.margin-bottom {
    margin-bottom: 130px;
}

.bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    background-color: #fff;
}

.bottom-button {
    background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
    color: #fff;
    width: 702px;
    height: 80px;
    border-radius: 16px;
    font-size: 32px;
}

.flex {
    display: flex;
    align-items: center;
    // justify-content: center;
}
</style>
